module.exports = __webpack_public_path__ + "img/grand-palm-kids-2.69128093.jpg";